import React from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./KtOrderCardItems.module.scss"

const KtOrderCardItems = props => {
  const { tableOrder } = props

  const i18n = useTranslation()[1]

  const tableOrderItems =
    tableOrder.items.filter(item =>
      !item.comboSet
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const getPortionLabel = portion => ({
    firstHalf: i18n.language === "fa" ? "نیمه اول" : "First half",
    secondHalf: i18n.language === "fa" ? "نیمه دوم" : "Second half"
  })[portion]

  return (
    tableOrderItems.map((orderItem, i) =>
      <div
        key={i}
        className={classes["text"]}
      >
        <div className={classes["bold"]}>
          {orderItem.foodName}{" "}
          <MdClose />
          {orderItem.quantity}
        </div>

        {!orderItem.isSimple ? `(${orderItem.option.name})` : ""}

        {orderItem.orderItemSpecifications.map(orderItemSpecification =>
          orderItemSpecification.specificationItems.map(specificationItem =>
            <div
              key={`${specificationItem.builderStepKey || "whole"}-${specificationItem.specificationItemId}`}
              className={clsx(
                classes["extraFood"],
                isLtr && classes["extraFood-ltr"]
              )}
            >
              {getPortionLabel(specificationItem.portion) &&
                <strong>{getPortionLabel(specificationItem.portion)}: </strong>
              }
              {specificationItem.name}
              <MdClose />
              {specificationItem.quantity * orderItem.quantity}
            </div>
          )
        )}
      </div>
    )
  )
}

export default KtOrderCardItems
